import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getPriceGroups, UsePriceGroupsProps } from 'Services/Query';

export const usePriceGroups = (
  filters: UsePriceGroupsProps = { searchStr: '' }
) => {
  const { data, error, isFetching, hasNextPage, fetchNextPage } =
    useInfiniteQuery(getPriceGroups(filters));

  const priceGroups = data?.pages.flatMap(page => page) || [];

  const fetchMore = useCallback(() => {
    if (hasNextPage) fetchNextPage();
  }, [hasNextPage, fetchNextPage]);

  return {
    priceGroups,
    loading: isFetching,
    error,
    fetchMore,
    hasNextPage
  };
};
